// Permission results
export const PERMISSION_UNAVAILABLE = 'unavailable';
export const PERMISSION_DENIED = 'denied';
export const PERMISSION_LIMITED = 'limited';
export const PERMISSION_GRANTED = 'granted';
export const PERMISSION_BLOCKED = 'blocked';
export const PERMISSION_UNRECOGNIZED = 'unrecognized';

// Permission keys
export const PERMISSION_IOS_CONTACTS = 'ios.CONTACTS';
export const PERMISSION_ANDROID_WRITE_CONTACTS = 'android.WRITE_CONTACTS';
export const PERMISSION_ANDROID_READ_CONTACTS = 'android.READ_CONTACTS';
